import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SalesPurchasesFilter } from 'app/_models/sales-purchases';
import { Ship } from 'app/_models/ship';
import { Entity } from 'app/_models/entity';
import { EntityService } from 'app/_services/entity.service';
import { SalesPurchasesService } from 'app/_services/sales-purchases.service';
import { ShipService } from 'app/_services/ship.service';
import { Filter } from 'app/shared/filter';
import { HttpErrorHandler } from 'app/shared/http-error-handler';
import { SelectItem } from 'primeng/primeng';
import { Profile } from 'app/_models/profile';

@Component({
  selector: 'app-sales-filter',
  templateUrl: './sales-filter.component.html',
  styleUrls: ['./sales-filter.component.css'],
})
export class SalesFilterComponent extends Filter implements OnInit {
  @Input() filterParams: any[];
  @Input() loading = false;
  @Output() onApplyFilter = new EventEmitter<string>();

  form: FormGroup;
  filter: SalesPurchasesFilter;

  ships: SelectItem[] = [];
  selectedShips: Ship[];

  sellers: SelectItem[] = [];
  selectedSellers: Entity[];

  buyers: SelectItem[] = [];
  selectedBuyers: Entity[];

  startDate: Date;
  endDate: Date;

  constructor(
    private fb: FormBuilder,
    private shipService: ShipService,
    private entityService: EntityService,
    private router: Router,
    private httpErrorHandler: HttpErrorHandler
  ) {
    super();
    this.form = fb.group({
      ship: [''],
      seller_entity: [''],
      buyer_entity: [''],
      start_date: [''],
      end_date: [''],
    });
  }

  ngOnInit() {
    this.filter = new SalesPurchasesFilter(this.filterParams);
    if (this.filter.start_date) {
      this.startDate = new Date(this.filter.start_date);
    }

    if (this.filter.end_date) {
      this.endDate = new Date(this.filter.end_date);
    }
    this.getShips();
    this.getSellers();
    this.getBuyers();
  }

  getShips() {
    this.shipService.list(1, 1000, '', '').subscribe(
      (response) => {
        this.ships = this.parseDropdownResults(response.results, new Ship(), 'name', false);
        this.selectedShips = this.selectMultipleDropdownItems(response.results, this.filter.ship);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  getSellers() {
    this.entityService.list(1, 1000, '&type=v&type=cv', '').subscribe(
      (response) => {
        this.sellers = this.parseDropdownResults(response, new Entity(), 'name', false);
        this.selectedSellers = this.selectDropdownItem(response, this.filter.seller_entity);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  getBuyers() {
    this.entityService.list(1, 1000, '&type=c&type=cv', '').subscribe(
      (response) => {
        this.buyers = this.parseDropdownResults(response, new Entity(), 'name', false);
        this.selectedBuyers = this.selectDropdownItem(response, this.filter.buyer_entity);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  onSubmit() {
    this.filter.reset();

    if (this.startDate) {
      this.startDate.setHours(23);
      this.filter.start_date = this.startDate.toISOString().substring(0, 10);
    }

    if (this.endDate) {
      this.endDate.setHours(23);
      this.filter.end_date = this.endDate.toISOString().substring(0, 10);
    }

    if (this.selectedShips) {
      this.filter.ship = this.selectedShips;
    }

    if (this.selectedBuyers) {
      this.filter.buyer_entity = this.selectedBuyers;
    }

    if (this.selectedSellers) {
      this.filter.seller_entity = this.selectedSellers;
    }

    const params = SalesPurchasesFilter.serializeRouterParams(this.filter);
    const serialize_params = this.filter.serializeQueryParams(params);
    this.onApplyFilter.emit(serialize_params);

    this.router.navigate(['/sales', SalesPurchasesFilter.serializeRouterParams(this.filter)]);
  }
}



// WEBPACK FOOTER //
// ./src/app/sales/sales-filter/sales-filter.component.ts